var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOnFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 0.5H38.5566C48.1083 0.50015 55.8514 8.24326 55.8516 17.7949V38.5566C55.8514 48.1083 48.1083 55.8514 38.5566 55.8516H17.7949C8.24326 55.8514 0.500151 48.1083 0.5 38.5566V17.7949C0.500174 8.24328 8.24328 0.500174 17.7949 0.5Z",
    fill: "url(#paint0_linear_60_15146)",
    stroke: "url(#paint1_linear_60_15146)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9945 25.6371C39.6439 25.6371 39.3076 25.7764 39.0597 26.0243C38.8118 26.2722 38.6725 26.6085 38.6725 26.9591C38.6725 29.6373 37.6086 32.2058 35.7148 34.0996C33.821 35.9934 31.2525 37.0573 28.5743 37.0573C25.8961 37.0573 23.3275 35.9934 21.4337 34.0996C19.54 32.2058 18.476 29.6373 18.476 26.9591C18.476 26.6085 18.3368 26.2722 18.0888 26.0243C17.8409 25.7764 17.5047 25.6371 17.154 25.6371C16.8034 25.6371 16.4672 25.7764 16.2192 26.0243C15.9713 26.2722 15.832 26.6085 15.832 26.9591C15.8365 30.108 17.0053 33.1439 19.1136 35.4828C21.222 37.8217 24.1208 39.2982 27.2523 39.6283V45.5773C27.2523 45.928 27.3916 46.2642 27.6395 46.5121C27.8874 46.7601 28.2237 46.8994 28.5743 46.8994C28.9249 46.8994 29.2612 46.7601 29.5091 46.5121C29.757 46.2642 29.8963 45.928 29.8963 45.5773V39.6283C33.0279 39.2985 35.9269 37.822 38.0352 35.4831C40.1436 33.1441 41.3123 30.108 41.3165 26.9591C41.3165 26.6085 41.1772 26.2722 40.9293 26.0243C40.6814 25.7764 40.3451 25.6371 39.9945 25.6371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5733 36.1901C31.021 36.1874 33.3677 35.2139 35.0985 33.4831C36.8293 31.7523 37.8029 29.4056 37.8056 26.9579V18.1342C37.8056 15.685 36.8326 13.3361 35.1008 11.6042C33.3689 9.87237 31.02 8.89941 28.5708 8.89941C26.1215 8.89941 23.7726 9.87237 22.0408 11.6042C20.3089 13.3361 19.3359 15.685 19.3359 18.1342V26.9579C19.3387 29.4065 20.3129 31.7539 22.0448 33.4849C23.7767 35.2158 26.1247 36.1888 28.5733 36.1901Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_15146",
    x1: 7.46367,
    y1: 1.51535,
    x2: 66.078,
    y2: 113.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_15146",
    x1: 6.75247,
    y1: -0.00000107404,
    x2: 62.2308,
    y2: 49.8024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E31DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_15146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(9.17578 9.17578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOnFill);
export default __webpack_public_path__ + "static/media/mic_on_fill.16d6430762addf21025156e7a8cda8ca.svg";
export { ForwardRef as ReactComponent };